import "./App.css";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import GuestRoutes from "./routes/GuestRoutes";
import UserRoutes from "./routes/UserRoutes";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/user" component={UserRoutes} />
        <Route path="/" component={GuestRoutes} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
